import TRANSLATION_ACCESSIBILITY_BG from './accessibility/translation';
import TRANSLATION_BOOKING_BG from './booking/translation';
import TRANSLATION_EVENTS_BG from './events/translation';
import TRANSLATION_EXPERIENCES_BG from './experiences/translation';
import TRANSLATION_FORM_BG from './form/translation';
import TRANSLATION_LANDING_PAGES_BG from './landingPages/translation';
import TRANSLATION_RESERVE_BG from './reserve/translation';
import TRANSLATION_SIGNIN_BG from './signin/translation';
import TRANSLATION_DATES_BG from './weekdays/translation';

export default {
  ...TRANSLATION_ACCESSIBILITY_BG,
  ...TRANSLATION_BOOKING_BG,
  ...TRANSLATION_DATES_BG,
  ...TRANSLATION_EVENTS_BG,
  ...TRANSLATION_EXPERIENCES_BG,
  ...TRANSLATION_FORM_BG,
  ...TRANSLATION_LANDING_PAGES_BG,
  ...TRANSLATION_RESERVE_BG,
  ...TRANSLATION_SIGNIN_BG,
};
